import { render } from "./FinanceIcon.vue?vue&type=template&id=68e785a6"
import script from "./FinanceIcon.vue?vue&type=script&lang=js"
export * from "./FinanceIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__